import { render, staticRenderFns } from "./RdInfoDashboard.vue?vue&type=template&id=61a8d503&"
import script from "./RdInfoDashboard.vue?vue&type=script&lang=js&"
export * from "./RdInfoDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports